import { BackwardOutlined, CaretRightOutlined, ForwardOutlined, PauseOutlined, StepBackwardOutlined, StepForwardOutlined } from '@ant-design/icons'
import { Button, Segmented, Slider, Space, Tag, Tooltip, Typography } from 'antd'
import { formatDuration } from '../lib/time'

interface Props {
  offsetSeconds: number
  durationSeconds: number
  playing: boolean
  speed: number
  speeds: number[]
  frameStep: number
  onSeek: (seconds: number) => void
  onPlayingChange: (playing: boolean) => void
  onSpeedChange: (speed: number) => void
}

export function Timeline({ offsetSeconds, durationSeconds, playing, speed, speeds, frameStep, onSeek, onPlayingChange, onSpeedChange }: Props) {
  const step = (direction: -1 | 1) => onSeek(Math.max(0, Math.min(durationSeconds, offsetSeconds + direction * frameStep)))
  return (
    <div className="timeline-panel">
      <div className="timeline-row timeline-primary">
        <Space size={6}>
          <Tooltip title="回到开始"><Button size="small" icon={<BackwardOutlined />} onClick={() => onSeek(0)} /></Tooltip>
          <Tooltip title={`上一帧（${(frameStep * 1000).toFixed(1)}ms）`}><Button size="small" icon={<StepBackwardOutlined />} onClick={() => step(-1)} /></Tooltip>
          <Button type="primary" shape="circle" icon={playing ? <PauseOutlined /> : <CaretRightOutlined />} onClick={() => onPlayingChange(!playing)} />
          <Tooltip title={`下一帧（${(frameStep * 1000).toFixed(1)}ms）`}><Button size="small" icon={<StepForwardOutlined />} onClick={() => step(1)} /></Tooltip>
          <Tooltip title="跳到结束"><Button size="small" icon={<ForwardOutlined />} onClick={() => onSeek(durationSeconds)} /></Tooltip>
        </Space>
        <Typography.Text className="timecode">{formatDuration(offsetSeconds)} <span>/ {formatDuration(durationSeconds)}</span></Typography.Text>
        <Tag color="cyan">max(ts) ≤ T</Tag>
        <Segmented size="small" value={speed} options={speeds.map(value => ({ label: `${value}×`, value }))} onChange={value => onSpeedChange(Number(value))} />
      </div>
      <Slider min={0} max={durationSeconds} step={0.01} value={offsetSeconds} tooltip={{ formatter: value => formatDuration(value ?? 0) }} onChange={onSeek} />
    </div>
  )
}

